// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"326":"551ef162","416":"95db8aa7","618":"cdc5c69a","675":"ad449ac4","791":"6ead8303"}[chunkId] + ".chunk.js";
};